import { APP_PDC_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const connectionsConstants = {
  FETCH_BUSINESS_CONSULTANTS_START: "FETCH_BUSINESS_CONSULTANTS_START",
  FETCH_BUSINESS_CONSULTANTS_SUCCESS: "FETCH_BUSINESS_CONSULTANTS_SUCCESS",
  FETCH_BUSINESS_CONSULTANTS_ERROR: "FETCH_BUSINESS_CONSULTANTS_ERROR"
};

export function fetchBusinessConsultants(auth, idAzienda) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: connectionsConstants.FETCH_BUSINESS_CONSULTANTS_START
      });
      let request = {
        method: "get",
        url: `${APP_PDC_URL}/anagrafica/businessconsultants?companyId=${idAzienda}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: connectionsConstants.FETCH_BUSINESS_CONSULTANTS_SUCCESS,
              payload: {
                list: result.data,
                idAzienda: idAzienda
              }
            });
            resolve(result);
          } else {
            dispatch({
              type: connectionsConstants.FETCH_BUSINESS_CONSULTANTS_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: connectionsConstants.FETCH_BUSINESS_CONSULTANTS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function setCommercialistaInList(accountant, idAzienda) {
  return (dispatch) => {
    let arrayCommercialista = [];
    arrayCommercialista.push(accountant);
    dispatch({
      type: connectionsConstants.FETCH_BUSINESS_CONSULTANTS_SUCCESS,
      payload: {
        list: arrayCommercialista,
        idAzienda: idAzienda
      }
    });
  };
}
